export const toaster = (_this, msg, position, duration) => {
  _this.$toasted.show(msg, {
    theme: "toasted-primary",
    duration: duration,
    position: position,
    closeOnSwipe: false,
    action: {
      text: "Close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  });
};

export function addVideoStream(streamId){
    let streamDiv=document.createElement("div"); // Create a new div for every stream
    streamDiv.id=streamId;                       // Assigning id to div
    streamDiv.style.transform="rotateY(180deg)"; // Takes care of lateral inversion (mirror image)
    document.getElementById("remote-container").appendChild(streamDiv);      // Add new div to container
}

export function removeVideoStream(evt) {
  // To remove subscribed remote stream.

  let stream = evt.stream;
  let remDiv = document.getElementById(stream.getId());
  remDiv && remDiv.remove();
  remDiv && remDiv.parentNode.removeChild(remDiv);
  stream.close();
  console.log("Remote stream is removed " + stream.getId());
}

export const startCall = rt => {
  // To join channel and subscribe stream.

  var streamObj = {
    localStream: null,
    remoteStream: null,
  };
  console.log("-===", rt.room_id);
  let handleFail = function(err) {
    console.log("Error : ", err);
  };
  // The client joins the channel
  rt.client.join(null, rt.room_id, null, uid => {
    console.log("join channel: " + " success, uid: " + uid);
    rt.uStreamId = uid;
    // Stream object associated with your web cam is initialized
    rt.localStream = AgoraRTC.createStream({
      streamID: uid,
      audio: true,
      video: false,
      screen: false
    });
    streamObj.localStream = rt.localStream;
    // Associates the stream to the client
    rt.localStream.init(() => {
      rt.client.publish(rt.localStream, handleFail);
    }, handleFail);
  });

  //When a stream is added to a channel
  rt.client.on("stream-added", evt => {
    rt.remoteStream = evt.stream;
    streamObj.remoteStream = rt.remoteStream;
    var id = rt.remoteStream.getId();
    if (id !== rt.uStreamId) {
      rt.client.subscribe(rt.remoteStream, handleFail);
    }
  });
  //When you subscribe to a stream
  rt.client.on("stream-subscribed", evt => {
    let stream = evt.stream;
    rt.remoteStream = evt.stream;
    console.log("===rt.remoteStream==", rt.remoteStream);
    rt.remoteStream && rt.remoteStream.play("remote-container");

    rt.remoteStream.setAudioVolume(50, function(err) {
      if (err) {
        console.error("Failed to set effects volume, reason: ", err);
      } else {
        console.log("Effects volume is set successfully");
      }
    });
  });

  rt.client.on("onAudioRouteChanged", evt => {
    console.log("===onAudioRouteChanged====", evt);
  });
  //When a person is removed from the stream
  rt.client.on("stream-removed", removeVideoStream);
  // rt.client.on("peer-leave");
  rt.client.on("client-role-changed", function(evt) {
    console.log("client-role-changed", evt.role);
    console.log("client-role-changed", evt);
  });
  return streamObj;
};

export const agoraInit = rt => {
  // To initiate agora

  rt.client = AgoraRTC.createClient({
    mode: "rtc",
    codec: "h264"
  });
  let handleFail = function(err) {
    console.log("Error : ", err);
  };
  // Client Setup
  // Defines a client for Real Time Communication
  // rt.client.enableInEarMonitoring(true);
  rt.client.init(
    "24d720d21ce748d499e936328229ac26",
    () => console.log("AgoraRTC client initialized"),
    handleFail
  );
};

export const permissionForCall = () => {
  // To allow JSbridge mic permission

  const _ = [
    "android.permission.CAMERA",
    "android.permission.RECORD_AUDIO",
    "android.permission.WRITE_EXTERNAL_STORAGE",
    "android.permission.READ_EXTERNAL_STORAGE"
  ];
  try {
    JSBridgePlugin.checkForPermission(
      _,
      true,
      "__native_money91.checkForPermissionResult"
    );
  } catch (err) {
    console.log(err);
  }
};

export const callUnsubscribe = $ => {
  //To unsubscribe remote stream and remove client

  // $.client.unsubscribe($.remoteStream, function(err) {
  //   console.log(err);
  // });
  // $.client && $.client.unpublish($.localStream);
  // $.localStream && $.localStream.close();
  // $.remoteStream && $.remoteStream.close();
  // $.client &&
  //   $.client.leave(
  //     () => {
  //       console.log("Client succeed to leave.");
  //     },
  //     () => {
  //       console.log("Client failed to leave.");
  //     }
  //   );
  window.rtsee.close(); 
};

export const setCallVolume = (rt, level) => {
  // To set speaker mode
  rt.remoteStream.setEffectsVolume(level, err => {
    if (err) {
      console.error("Failed to set effects volume, reason: ", err);
    } else {
      console.log("Effects volume is set successfully");
      rt.toasterData = {
        status: true,
        msg:  rt.speakerOn ? "Speaker off" : "Speaker On",
        timeoutMs: "5000",
        color: "#330028"
      };
    }
  });
  return;
};


/* eslint-env browser */
const ENDPOINT = 'voice-test.services-money91.com:8800'

export async function callMake(roomId) {
  console.log('==room_id=',roomId, window.RTSee, document.querySelector('#remote'))
  window.rtsee = new window.RTSee()
  await window.rtsee.broadcast({
    debug: true,
    roomId,
    endpoint: ENDPOINT,
    video: false,
    save: false,
  })
}
window.callMake = callMake

